import React from "react";
import "./AccountTypeSelection.scss";
import { IAccountType } from "../../interfaces/userManagement.interface";

interface AccountTypeSelectionProps {
  accountTypes: IAccountType[];
  selectedType: IAccountType | null;
  onSelect: (accountType: IAccountType) => void;
  onNext: () => void;
  isLoading?: boolean;
}

const AccountTypeSelection: React.FC<AccountTypeSelectionProps> = ({
  accountTypes,
  selectedType,
  onSelect,
  onNext,
  isLoading = false,
}) => {
  const getAccountTypeIcon = (type: string) => {
    switch (type) {
      case "ENTERPRISE":
        return (
          <div className="account-type-icon enterprise">
            <svg width="48" height="48" viewBox="0 0 20 19" fill="none">
              <path
                d="M19.4236 8.20535C19.2997 7.24643 18.3007 6.59034 17.3454 6.94807C16.9876 7.08315 16.5572 6.88202 16.3954 6.52131C16.2024 6.09085 15.9657 5.67819 15.6903 5.29522C15.4446 4.95381 15.4914 4.50776 15.7964 4.25541C16.1609 3.95631 16.3642 3.51397 16.3546 3.04267C16.3449 2.56396 16.1193 2.12311 15.7356 1.83142C15.104 1.35345 14.4152 0.954887 13.6879 0.648359C13.4913 0.565977 13.2857 0.524414 13.0756 0.524414C12.3171 0.524414 11.6773 1.06324 11.5541 1.80618C11.4896 2.19657 11.1192 2.46153 10.7028 2.41625C10.2405 2.36727 9.75953 2.36727 9.29789 2.41625C8.883 2.46152 8.51191 2.19581 8.44659 1.80618C8.32265 1.06324 7.68288 0.524414 6.92436 0.524414C6.71432 0.524414 6.50874 0.56672 6.31355 0.648359C5.58473 0.954887 4.89598 1.35269 4.26439 1.83142C3.88143 2.12311 3.6558 2.56396 3.64615 3.04193C3.6365 3.51397 3.83986 3.95556 4.20428 4.25615C4.51007 4.507 4.55534 4.95381 4.31041 5.29372C4.03506 5.67743 3.79756 6.09009 3.60384 6.52055C3.44278 6.88125 3.04349 7.09352 2.64566 6.94435C2.47125 6.87904 2.29015 6.84564 2.1061 6.84564C1.33348 6.84564 0.676651 7.42974 0.575704 8.20458C0.525977 8.59794 0.5 8.99947 0.5 9.39579C0.5 9.79211 0.525977 10.1936 0.576445 10.5863C0.699649 11.5444 1.69714 12.2005 2.65467 11.8435C3.01166 11.7084 3.44287 11.9096 3.60467 12.2703C3.79764 12.7008 4.0344 13.1134 4.30975 13.4964C4.55542 13.8378 4.50866 14.2838 4.20361 14.5362C3.83919 14.8353 3.63584 15.2776 3.64549 15.7489C3.65514 16.2276 3.88076 16.6685 4.26447 16.9602C4.89607 17.4382 5.58482 17.8367 6.31211 18.1432C6.5088 18.2256 6.71438 18.2672 6.92442 18.2672C7.68294 18.2672 8.32271 17.7284 8.44591 16.9854C8.51048 16.595 8.88158 16.3338 9.2972 16.3754C9.75885 16.4243 10.2398 16.4243 10.7022 16.3754C11.1185 16.333 11.4881 16.5958 11.5535 16.9854C11.6767 17.7284 12.3164 18.2664 13.0749 18.2672C13.285 18.2672 13.4906 18.2249 13.6858 18.1432C14.4131 17.8367 15.1026 17.4397 15.7334 16.9602C16.1164 16.6685 16.3427 16.2276 16.3524 15.7497C16.362 15.2776 16.1587 14.836 15.7943 14.5355C15.4885 14.2846 15.4432 13.8378 15.6881 13.4979C15.9635 13.1149 16.201 12.7023 16.3939 12.2718C16.5557 11.9103 16.955 11.6988 17.3528 11.848C17.5273 11.914 17.7084 11.9467 17.8917 11.9467C18.6643 11.9467 19.3211 11.3626 19.4221 10.5878C19.474 10.1899 19.5 9.78991 19.5 9.39581C19.5 9.00171 19.4741 8.60167 19.4236 8.20535ZM9.99996 12.5628C8.25359 12.5628 6.83303 11.1423 6.83303 9.39589C6.83303 7.64952 8.25359 6.22896 9.99996 6.22896C11.7463 6.22896 13.1669 7.64952 13.1669 9.39589C13.1669 11.1423 11.7463 12.5628 9.99996 12.5628Z"
                fill="white"
              />
            </svg>
          </div>
        );
      case "FEDERATION":
        return (
          <div className="account-type-icon federation">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                fill="white"
              />
              <path
                d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
                fill="white"
              />
            </svg>
          </div>
        );
      case "TRANSPORTER":
        return (
          <div className="account-type-icon transporter">
            <svg width="48" height="48" viewBox="0 0 26 16" fill="none">
              <path
                d="M22.427 13.0312C22.427 14.6292 21.1321 15.9241 19.5355 15.9241C17.9375 15.9241 16.6426 14.6292 16.6426 13.0312C16.6426 11.4346 17.9375 10.1396 19.5355 10.1396C21.1321 10.1396 22.427 11.4346 22.427 13.0312Z"
                fill="white"
              />
              <path
                d="M17.9306 3.27432V2.47194C17.9306 1.58297 17.2094 0.867188 16.3259 0.867188H2.54994C1.66096 0.867188 0.94518 1.58837 0.94518 2.47194V7.50672C0.673209 7.74893 0.5 8.09531 0.5 8.48229C0.5 9.21567 1.10078 9.80966 1.82737 9.80966H2.13316C2.31177 9.80966 2.48496 9.76907 2.64734 9.70547H2.65952V9.72306C3.33471 9.21567 4.16008 8.89769 5.07206 8.89769C7.2884 8.89769 9.09088 10.6986 9.09088 12.9165H15.522C15.522 11.2711 16.5151 9.86259 17.9345 9.23888L17.9358 3.27439L17.9306 3.27432Z"
                fill="white"
              />
              <path
                d="M7.95976 13.0312C7.95976 14.6292 6.66485 15.9241 5.0682 15.9241C3.4702 15.9241 2.17529 13.6292 2.17529 13.0312C2.17529 11.4346 3.4702 10.1396 5.0682 10.1396C6.66485 10.1396 7.95976 11.4346 7.95976 13.0312Z"
                fill="white"
              />
              <path
                d="M25.1641 8.83446V5.68855L24.2751 3.9106C23.8774 3.11362 22.8382 2.47363 21.9492 2.47363H18.7329V8.98472C18.9927 8.93331 19.2647 8.90354 19.5353 8.90354C21.7516 8.90354 23.5541 10.7045 23.5541 12.9224C24.4431 12.9224 25.1589 12.2012 25.1589 11.3176V11.3C25.3496 11.2824 25.4998 11.1322 25.4998 10.936L25.4985 9.19867C25.5053 9.00247 25.3481 8.85747 25.1641 8.83446ZM20.3375 6.49093V3.27462H21.9423C22.3875 3.27462 22.907 3.59801 23.1032 3.99581L24.0098 5.81436V6.49089L20.3375 6.49093Z"
                fill="white"
              />
            </svg>
          </div>
        );
      default:
        return null;
    }
  };

  const getKeyFeatures = (type: string) => {
    switch (type) {
      case "ENTERPRISE":
        return [
          "Manage multiple federations",
          "Create and manage transporters",
          "Full system administration",
          "Advanced analytics and reporting",
        ];
      case "FEDERATION":
        return [
          "Manage transporters under your federation",
          "Create and assign drivers",
          "Track fleet operations",
          "Generate federation reports",
        ];
      case "TRANSPORTER":
        return [
          "Manage trucks and trailers",
          "Assign drivers to vehicles",
          "Track deliveries and routes",
          "View trip history and analytics",
        ];
      default:
        return [];
    }
  };

  return (
    <div className="account-type-selection">
      <div className="account-types-grid">
        {accountTypes.map((accountType) => (
          <div
            key={accountType.type}
            className={`account-type-card ${
              selectedType?.type === accountType.type ? "selected" : ""
            }`}
            onClick={() => onSelect(accountType)}
          >
            {getAccountTypeIcon(accountType.type)}

            <div className="account-type-content">
              <h3 className="account-type-title">{accountType.title}</h3>
              <p className="account-type-description">
                {accountType.description}
              </p>

              <div className="features-section">
                <h4>Key Features:</h4>
                <ul className="features-list">
                  {getKeyFeatures(accountType.type).map((feature, index) => (
                    <li key={index} className="feature-item">
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="check-icon"
                      >
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="selection-indicator">
              {selectedType?.type === accountType.type && (
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountTypeSelection;
